import React from "react"
import { useNavigate, } from "react-router-dom";
import { MenuItem } from "react-pro-sidebar";
import { useDispatch, useSelector } from "react-redux";
import { Typography, } from "@mui/material";

import { setClassId, setClassName, setSubjectName, setYear } from "../../store/markingSlice";
import { setSelect, setStyleProps } from "../../store/stylesSlice";
import { Common, NavigationBar } from "../../helper"
import { setPupilSavedReport } from "../../store/pupilProgressSlice";

const Item = (props) => {
  const { title, to, icon, setSelectedClass, i, setSelectTab, selectTab, setMyClasses, overRideSelected, className, year, classId,setIsCollapsed,isCollapsed } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const select = useSelector((state) => state.styleData.select)
  
  const isSelected = select === title;
  // const isSelected = select === title && title !== "Class Home";
  return (
    <MenuItem
      active={select === title}
      style={{ color: ((overRideSelected && selectTab) || isSelected) ? "#FFA177" : "#FFF" }}
      onClick={() => {
        if(isCollapsed){
          setIsCollapsed(false)
          dispatch(setStyleProps({ isNavCollapsed: false }))
        }else{
          if (title !== "Class Home") {
            setMyClasses(false);
            navigate(to);
            sessionStorage.removeItem("savedReports")
            sessionStorage.removeItem(Common.EKey)
            dispatch(setPupilSavedReport({}))
          } else if (title === "My Classes") {
            setSelectedClass(i);
            dispatch(setSelect(NavigationBar.MyClasses))
          }
          else {
            setSelectTab(true);
            dispatch(setClassId(classId));
            dispatch(setClassName(className));
            dispatch(setYear(year));
            dispatch(setSubjectName(""));
            dispatch(setSelect(NavigationBar.ClassHome))
            navigate(to);
            
          }
        }
      }}
      icon={icon}
    >
      <Typography>{title}</Typography>
    </MenuItem>
  );
};

export { Item }
